import { createContext } from 'react'
import type { ResponsiveCtx } from './types'

export const ResponsiveContext = createContext<ResponsiveCtx>(null as any)
